export const addDataToInput = (inputName: string, inputValue: string, data: string): string => {
    // Get the element (We assume unique names, so we just select the 1st item)
    // DENNIS 2023-12: @todo Better use getElementById, because on HTML level, identifiers should be unique.
    const element = document.getElementsByName(inputName)[0];

    if (!element) {
        throw new Error("Element not found");
    }

    if (!(element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement)) {
        throw new Error("Element is not input");
    }

    element.focus();
    const caretLocation = element.selectionStart ?? inputValue.length;

    // Place emoji in location of caret
    inputValue = `${inputValue.slice(0, caretLocation)}${data}${inputValue.slice(caretLocation)}`;

    // Put caret after emoji
    const position = caretLocation + data.length;
    element.setSelectionRange(position, position);

    // Return value so we can update fields
    return inputValue;
};
